enum OrientationDialogFields {
	DIRECTION = 'direction',
	ORIENTATION = 'orientation'
}

export default OrientationDialogFields;